// import React, { useState, useEffect, useRef } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import "./BottomNav.css";
// import companylogo from "../../assets/logo/logo192.png";

// const ICONS = [
//   { icon: "fa-solid fa-house", label: "Home", path: "/" },
//   { icon: "fa-solid fa-bag-shopping", label: "Shop", path: "/student/cart" },
//   { icon: "fa-solid fa-star", label: "Market", path: "/market" },
//   { icon: "fa-solid fa-user", label: "Profile", path: "/profile" },
// ];

// function NavBar() {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const liRefs = useRef([]);
//   const [positionX, setPositionX] = useState(208);
//   const [activeIndex, setActiveIndex] = useState(2);

//   useEffect(() => {
//     const matchedIndex = ICONS.findIndex(
//       (item) => item.path === location.pathname
//     );
//     if (matchedIndex !== -1) {
//       setActiveIndex(matchedIndex);
//     }
//   }, [location.pathname]);

//   useEffect(() => {
//     const activeLi = liRefs.current[activeIndex];
//     if (activeLi) {
//       const newPositionX = activeLi.offsetLeft;
//       setPositionX(newPositionX);
//     }
//   }, [activeIndex]);

//   const handleClick = (index) => {
//     setActiveIndex(index);
//     navigate(ICONS[index].path);
//   };

//   return (
//     <nav
//       style={{
//         "--position-x-active": positionX !== null ? `${positionX}px` : "0px",
//       }}
//     >
//       <ul>
//         {ICONS.map((item, index) => (
//           <li
//             key={item.icon}
//             ref={(el) => (liRefs.current[index] = el)}
//             className={index === activeIndex ? "active" : ""}
//             onClick={() => handleClick(index)}
//           >
//             <i
//               className={item.icon}
//               style={{
//                 display: index === activeIndex ? "none" : "block",
//               }}
//             ></i>
//             <span style={{ fontSize: "1rem" }} className="icon-label">
//               {item.label}
//             </span>
//           </li>
//         ))}
//       </ul>
//       <div className="effect">
//         <div
//           className="circle"
//           style={{
//             height: "56px",
//             width: "56px",
//             background: "#FF0051",
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//             padding: "1rem",
//           }}
//         >
//           <img
//             src={companylogo}
//             alt="Company Logo"
//             style={{
//               height: "56px",
//               width: "56px",
//               objectFit: "contain",
//             }}
//           />
//         </div>
//       </div>
//     </nav>
//   );
// }

// export default NavBar;

import React, { useState, useEffect } from "react";
import { BottomNavigation, BottomNavigationAction, Paper } from "@mui/material";
import HomeIcon from "@mui/icons-material/HomeOutlined";
import AccountCircleIcon from "@mui/icons-material/AccountCircleOutlined";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCartOutlined";
import StarRateIcon from "@mui/icons-material/StarBorderPurple500Outlined";
import LoginIcon from "@mui/icons-material/LoginOutlined";
import { useNavigate } from "react-router-dom";
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
const BottomNav = () => {
  const [value, setValue] = useState(0);
  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    // Check if user exists in session storage
    const user = sessionStorage.getItem("user");
    setIsAuthenticated(!!user);
  }, []);

  return (
    <Paper
      sx={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
        boxShadow: "0px -2px 8px rgba(0, 0, 0, 0.1)",
      }}
      elevation={5}
    >
      <BottomNavigation
        value={value}
        onChange={(event, newValue) => setValue(newValue)}
        showLabels
        sx={{
          backgroundColor: "#fff",
          paddingTop: "2rem",
          paddingBottom: "1.8rem",
        }}
      >
        <BottomNavigationAction
          onClick={() => navigate("/")}
          label="Home"
          icon={<HomeIcon sx={{ fontSize: "2rem" }} />}
          sx={{
            color: value === 0 ? "#2874F0" : "#878787",
            fontSize: "1.1rem",
            fontWeight: 600,
          }}
        />
        <BottomNavigationAction
          onClick={() => navigate("/market")}
          label="Market"
          icon={<TrendingUpIcon sx={{ fontSize: "2rem" }} />}
          sx={{
            color: value === 1 ? "#2874F0" : "#878787",
            fontSize: "1.1rem",
            fontWeight: 600,
          }}
        />
        <BottomNavigationAction
          onClick={() => navigate("/student/cart")}
          label="Cart"
          icon={<ShoppingCartIcon sx={{ fontSize: "2rem" }} />}
          sx={{
            color: value === 2 ? "#2874F0" : "#878787",
            fontSize: "1.1rem",
            fontWeight: 600,
          }}
        />
        {/* Updated Account/Login logic based on session storage */}
        <BottomNavigationAction
          onClick={() => navigate(isAuthenticated ? "/profile" : "/login")}
          label={isAuthenticated ? "Account" : "Login"}
          icon={
            isAuthenticated ? (
              <AccountCircleIcon sx={{ fontSize: "2rem" }} />
            ) : (
              <LoginIcon sx={{ fontSize: "2rem" }} />
            )
          }
          sx={{
            color: value === 3 ? "#2874F0" : "#878787",
            fontSize: "1.1rem",
            fontWeight: 600,
          }}
        />
      </BottomNavigation>
    </Paper>
  );
};

export default BottomNav;
